import { HttpResponse, HttpStatusEnum } from '@core/api';
import { TimezoneHelper } from '@shared/helpers';
import { MessagePayload, MessageResponse } from '@shared/types';

function mapGetMessagesPayload(payload: MessagePayload) {
    return {
        filters: {
            strainId: payload.strainId,
            skip: payload.skip,
            take: payload.take,
        },
    };
}

function mapGetMessages(data: any): HttpResponse<MessageResponse> {
    return {
        status: HttpStatusEnum.SUCCESS,
        data: {
            totalCount: data?.totalCount || 0,
            messages: (data?.messages || []).map((s: any) => {
                return {
                    id: s.userMessageId,
                    dateSent: TimezoneHelper.formatMomentDateAndTime(s.dateSent),
                    subject: s.subject,
                    message: s.body,
                    isExpanded: false,
                };
            }),
        },
    };
}

export const MessageMapper = {
    mapGetMessagesPayload,
    mapGetMessages,
};
